// extracted by mini-css-extract-plugin
module.exports = {"venusModalWrapper":"VenusModal_venusModalWrapper__1jysT","venusFullScreenModalWrapper":"VenusModal_venusFullScreenModalWrapper__iqFS5"};